import { useEffect, useState } from "react";

const PIECE_DELAY_MS = 1400;

// Pieces of the newest agent reply land one at a time so the pacing of a
// multi-text reply can be felt, not just read. Clicking shows the rest.
export function usePieceReveal(count: number, animate: boolean) {
  const [revealed, setRevealed] = useState(animate ? 1 : count);

  useEffect(() => {
    if (revealed >= count) return;
    const timer = setTimeout(() => {
      setRevealed((n) => n + 1);
    }, PIECE_DELAY_MS);
    return () => {
      clearTimeout(timer);
    };
  }, [revealed, count]);

  const revealAll = () => {
    setRevealed(count);
  };

  return { revealed: Math.min(revealed, count), revealAll };
}
